import { logger } from "@/infrastructure/services/LoggerService";
class EventBus {
    constructor() {
        Object.defineProperty(this, "events", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    emit(event, payload) {
        const handlers = this.events.get(event);
        if (handlers) {
            handlers.forEach((handler) => {
                try {
                    handler(payload);
                }
                catch (error) {
                    logger.error(`[EventBus] Error in handler for event "${event}":`, error);
                }
            });
        }
    }
    // Generic in T to match ShellEventBus: callers pass a handler typed for the payload they
    // expect, while the bus stores handlers untyped (hence the cast to EventHandler).
    on(event, handler) {
        if (!this.events.has(event)) {
            this.events.set(event, new Set());
        }
        this.events.get(event).add(handler);
    }
    off(event, handler) {
        const handlers = this.events.get(event);
        if (handlers) {
            handlers.delete(handler);
        }
    }
    clear() {
        this.events.clear();
    }
}
export const eventBus = new EventBus();
/**
 * Composable for using Event Bus in components
 * @returns ShellEventBus instance
 */
export function useEventBus() {
    return eventBus;
}
